module.exports = __webpack_public_path__ + "static/media/homepage-reliable-api.4eac3f7b.svg";